import moment from "moment";

import { PaymentTypes } from "types";

import {
	accountNumberFieldName,
	bankAccountFieldName,
	bankFieldName,
	cardHolderNameFieldName,
	cardNumberFieldName,
	cardTypeFieldName,
	customerIdFieldName,
	cvvFieldName,
	expirationDateFieldName,
	id,
	payeeFirstNameFieldName,
	payeeLastNameFieldName,
	paymentMethodStatusFieldName,
	paymentTypeFieldName,
	routingNumberFieldName,
} from "./paymentMethodConstants";

export const getDefaultValuesForPaymentMethodForm = (data, format = "") => {
	const expirationDate = (month, year, format) => {
		let formattedYear = moment(year, "YYYY").format("YY");
		if (format === "MM") {
			month = moment(month, "MM").format("MM");
		}
		return `${month}/${formattedYear}`;
	};

	const isAchPaymentMethod = data?.payment_type === PaymentTypes.ach.name;
	const isCreditCardPaymentMethod =
		data?.payment_type === PaymentTypes.creditCard.name;

	const generalValues = {
		[paymentTypeFieldName]:
			PaymentTypes?.getByName(data?.payment_type) || "",
		[paymentMethodStatusFieldName]: data?.is_active,
		[id]: data?.id,
	};

	const customerId = data?.credit_card?.customer_id;

	const creditCardValues = {
		[customerIdFieldName]: customerId,
		[cardTypeFieldName]: data?.credit_card?.network,
		[cardHolderNameFieldName]: data?.credit_card?.holder_name,
		[cardNumberFieldName]: `**** ${data?.credit_card?.last_digits}`,
		[expirationDateFieldName]: expirationDate(
			data?.credit_card?.expiration_month,
			data?.credit_card?.expiration_year,
			format,
		),
		[cvvFieldName]: "***",
		[payeeFirstNameFieldName]: data?.payee_first_name,
		[payeeLastNameFieldName]: data?.payee_last_name,
	};

	const achValues = {
		[accountNumberFieldName]: data?.ach?.account_number,
		[bankAccountFieldName]: data?.ach?.bank_account_name,
		[bankFieldName]: data?.ach?.bank_name,
		[routingNumberFieldName]:
			{
				label: data?.ach?.routing_number,
				value: data?.ach?.routing_number,
			} || {},
	};

	if (isCreditCardPaymentMethod) {
		return { ...generalValues, ...creditCardValues };
	} else if (isAchPaymentMethod) {
		return {
			...generalValues,
			...achValues,
		};
	} else {
		return {};
	}
};
